<template>
  <div id="app">
    <main>
      <content>
        <header class="header">
          <Headline/>
          <Title @toggleMenuChange="toggleMenuChange"/>
          <Nav :toggleMenu="toggleMenu"/>
        </header>
        <div class="wrapper">
          <Flyer/>
          <FlyerR/>
          <!--<Slides/>-->
          <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
          <router-view></router-view>
        </div>
      </content>
    </main>
  </div>
</template>

<script>
  // import HelloWorld from './views/HelloWorld.vue'
  import Headline from './views/header/Headline.vue'
  import Title from './views/header/Title.vue'
  import Nav from './views/header/Nav.vue'
  import Flyer from './views/home/Flyer.vue'
  import FlyerR from './views/home/FlyerR.vue'
  import UserService from './services/user.service'
  import EventService from './services/event.service'
  import TeamService from './services/team.service'
  //import TeamService from './services/team.service'

  export default {
    name: 'app',
    // baseurl: 'v2',
    components: {
      // HelloWorld,
      Headline,
      Title,
      Nav,
      Flyer,
      FlyerR,
    },
    created() {
      const promises = [
        UserService.init(),
        EventService.init(),
        TeamService.init(),
        // TeamService.init()
      ]
      return Promise.all(promises)
    },
    data() {
      return {
        toggleMenu: 0
      }
    },
    methods: {
      toggleMenuChange(toggleMenu) {
        console.log("toggleMenuChange")
        this.toggleMenu = toggleMenu;
      }
    }
  }
</script>

<style lang="stylus">
  *
    font-family 'Titillium Web', sans-serif !important
  body
    margin 0
  #app
    color: rgb(84, 101, 113);
    /*.policy*/
      /*position fixed*/
      /*bottom: 0*/
      /*right 0*/
    .color
      color #51a7ff
    .bg
      background-color: #51a7ff !important;
      color white
    .box
      box-shadow 0 10px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
      margin-bottom 20px
    .wrapper
      margin 0 auto
      max-width 920px
      position relative
      @media screen and (max-width: 1200px)
        max-width 100%
        width 100%
    main
      width 1400px
      margin auto
      height 0
      @media screen and (max-width: 1200px)
        width 100%
    .pointer    
      cursor pointer
    a
      text-decoration none
      color #3f94ff
      cursor: pointer;
      &.button
        color #ffffff
    .m8
      margin auto 8px
    .bold
      font-weight 700
    .larger
      font-size larger
    .text-center
      text-align center
    .text-right
      text-align right
    .row
      margin 10px 0
    .grid
      > div
        display flex
        > div
          flex 1
          overflow hidden
          white-space nowrap
          text-overflow ellipsis
          text-align center
          &.f2
            flex 2
          &.f3
            flex 3
          &.f4
            flex 4
    ::placeholder
      color #7abcff
    textarea:focus, input:focus
      outline none
    .button
      color white
      text-transform uppercase
      text-align center
      border 1px solid #aaa
      padding 10px
      box-sizing border-box
      flex 1
    .blue
      background #7abcff
      background -moz-linear-gradient(top, #7abcff 0%, #60abf8 44%, #4096ee 100%)
      background -webkit-gradient(linear, left top, left bottom, color-stop(0%, #7abcff), color-stop(44%, #60abf8), color-stop(100%, #4096ee))
      background -webkit-linear-gradient(top, #7abcff 0%, #60abf8 44%, #4096ee 100%)
      background -o-linear-gradient(top, #7abcff 0%, #60abf8 44%, #4096ee 100%)
      background -ms-linear-gradient(top, #7abcff 0%, #60abf8 44%, #4096ee 100%)
      background linear-gradient(top, #7abcff 0%, #60abf8 44%, #4096ee 100%)
    .button:hover {
      -webkit-box-shadow:rgba(0,0,0,0.7) 0px 5px 15px, inset rgba(0,0,0,0.15) 0px -10px 20px !important;
      -khtml-box-shadow:rgba(0,0,0,0.7) 0px 5px 15px, inset rgba(0,0,0,0.15) 0px -10px 20px !important;
      -moz-box-shadow:rgba(0,0,0,0.7) 0px 5px 15px, inset rgba(0,0,0,0.15) 0px -10px 20px !important;
      -o-box-shadow:rgba(0,0,0,0.7) 0px 5px 15px, inset rgba(0,0,0,0.15) 0px -10px 20px !important;
      box-shadow:rgba(0,0,0,0.7) 0px 5px 15px, inset rgba(0,0,0,0.15) 0px -10px 20px !important;
    }
    .button.router-link-active {
      -webkit-box-shadow: rgba(255,255,255,0.25) 0px 1px 0px, inset rgba(255,255,255,0.03) 0px 20px 0px, inset rgba(0,0,0,0.15) 0px -20px 20px, inset rgba(255,255,255,0.05) 0px 20px 20px !important;
      -khtml-box-shadow: rgba(255,255,255,0.25) 0px 1px 0px, inset rgba(255,255,255,0.03) 0px 20px 0px, inset rgba(0,0,0,0.15) 0px -20px 20px, inset rgba(255,255,255,0.05) 0px 20px 20px !important;
      -moz-box-shadow: rgba(255,255,255,0.25) 0px 1px 0px, inset rgba(255,255,255,0.03) 0px 20px 0px, inset rgba(0,0,0,0.15) 0px -20px 20px, inset rgba(255,255,255,0.05) 0px 20px 20px !important;
      -o-box-shadow: rgba(255,255,255,0.25) 0px 1px 0px, inset rgba(255,255,255,0.03) 0px 20px 0px, inset rgba(0,0,0,0.15) 0px -20px 20px, inset rgba(255,255,255,0.05) 0px 20px 20px !important;
      box-shadow: rgba(255,255,255,0.25) 0px 1px 0px, inset rgba(255,255,255,0.03) 0px 20px 0px, inset rgba(0,0,0,0.15) 0px -20px 20px, inset rgba(255,255,255,0.05) 0px 20px 20px !important;
    }
</style>
